import React               from 'react';
import DisplayStatusDXYBox from './DisplayStatusDXYBox';

function DisplayStatusDXYRow( { key, row } ) {
    return(<> 
             { row ? (<> 
               { row.map( (rec, index ) => (
                   <DisplayStatusDXYBox key={index} rec={rec}/> ))} 
               </>) : (<>Loading...</>) }
           </>);
}

export default DisplayStatusDXYRow;
